import { render, staticRenderFns } from "./SNList.vue?vue&type=template&id=a6e55720&scoped=true"
import script from "./SNList.vue?vue&type=script&lang=ts"
export * from "./SNList.vue?vue&type=script&lang=ts"
import style0 from "./SNList.vue?vue&type=style&index=0&id=a6e55720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e55720",
  null
  
)

export default component.exports